import { setRange } from './helpers';

export const setPrice = setRange('price');
